import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

function About() {
  useEffect(() => {
    document.title = `Our story | ${siteConfig.brandName}`;
  }, []);

  return (
    <main className="about-page">
      <header className="about-page__header">
        <nav aria-label="Breadcrumb"><Link to="/">Home</Link><span>/</span><span>Our story</span></nav>
        <p className="eyebrow">About {siteConfig.logoText}</p>
        <h1>Our story</h1>
      </header>

      <div className="about-page__hero">
        <img src="/img/editorial/about-hero.jpg" alt="The trbanlantern creative studio" />
      </div>

      <section className="about-page__manifesto">
        <p className="eyebrow">Designed for daily rhythm</p>
        <h2>
          We make clothes for the rhythm of real life — soft in feeling, clear in
          shape and designed to stay relevant.
        </h2>
      </section>

      <section className="about-page__split">
        <img src="/img/editorial/about-studio-look.jpg" alt="A longline blouse in the trbanlantern studio" />
        <blockquote>
          <p>“The simple pieces are the ones we return to. They give us room to move, layer and live.”</p>
          <cite>trbanlantern design studio</cite>
        </blockquote>
      </section>

      <section className="about-page__copy">
        <p className="eyebrow">Quietly considered</p>
        <div>
          <h2>A wardrobe in conversation</h2>
          <p>
            {siteConfig.description} Every shape is considered alongside the
            pieces that came before it, so a new season feels like a continuation,
            not a reset.
          </p>
          <p>
            Relaxed silhouettes, tactile fabrics and small unexpected details form
            our visual language. The result is a wardrobe that can be worn at home,
            across the city and wherever the day changes direction.
          </p>
        </div>
      </section>

      <section className="about-page__responsibility">
        <p className="eyebrow">Made with time in mind</p>
        <div>
          <h2>Care is part of the design.</h2>
          <p>
            We prioritise certified and lower-impact fibres where possible, work
            with experienced makers and choose constructions intended for repeated
            wear. Longevity begins with a piece you genuinely want to live in.
          </p>
          <Link to="/shop">Discover the collection</Link>
        </div>
      </section>
    </main>
  );
}

export default About;
